import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-cross",
  "use": "spr-cross-usage",
  "viewBox": "0 0 29.263 29.263",
  "content": "<symbol viewBox=\"0 0 29.263 29.263\" id=\"spr-cross\">\n<path d=\"M28.764,26.407L16.988,14.631L28.774,2.845c0.651-0.652,0.652-1.706,0.001-2.357\n\tc-0.65-0.65-1.705-0.65-2.356,0.001L14.632,12.275L2.856,0.499C2.206-0.152,1.151-0.151,0.5,0.5s-0.651,1.706-0.001,2.356\n\tl11.776,11.776L0.489,26.418c-0.651,0.651-0.651,1.706-0.001,2.356c0.651,0.651,1.705,0.65,2.356-0.001L14.63,16.988l11.776,11.776\n\tc0.65,0.65,1.705,0.65,2.355-0.001C29.415,28.112,29.415,27.057,28.764,26.407z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ../img/sprite/cross.svg
// module id = 315
// module chunks = 0